/**
 * Search in the reports list.
 *
 * Without a % the term is a plain, case-insensitive "contains" match.
 * With a % it works like SQL LIKE in MyFashionManager's search box, which
 * wraps the term as LIKE "%term%" (Reports2_OverviewUnit / MyReports2_
 * OverviewUnit.pas :402): % = any run of characters, _ = exactly one, the
 * rest literal; every field is matched on its own.
 */
const escapeRegExp = (text) => text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const isLikePattern = (term) => typeof term === 'string' && term.indexOf('%') !== -1;

export const likeToRegExp = (term) => {
    const body = String(term).split('').map((ch) => {
        if (ch === '%') return '.*';
        if (ch === '_') return '.';
        return escapeRegExp(ch);
    }).join('');
    return new RegExp(body, 'i');
};

/** A predicate over a list of field values (null/undefined skipped). */
export const makeMatcher = (term) => {
    const raw = typeof term === 'string' ? term : '';
    if (raw.trim() === '') return () => true;
    if (isLikePattern(raw)) {
        const re = likeToRegExp(raw);
        return (fields) => (fields || []).some(f => f !== null && f !== undefined && re.test(String(f)));
    }
    const needle = raw.toLowerCase();
    return (fields) => (fields || [])
        .filter(f => f !== null && f !== undefined && f !== '')
        .map(String)
        .join(' ')
        .toLowerCase()
        .includes(needle);
};
